import React from 'react';

import { cn } from '@change/ds-utils';

import { Text } from '@change/ds-core-ui/next';

import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconStar } from '@change-corgi/design-system-legacy/icons';

import { Badge } from './Badge';
import { Button } from './Button';

export type ComplexProps = React.PropsWithChildren<{
	type: 'complex';
	label: string;
	description: string;
	selected: boolean;
	onSelect: () => void;
	badgeText: string | undefined;
	Radio?: React.FC | undefined;
}>;

export function Complex({
	label,
	selected,
	onSelect,
	description,
	badgeText,
	Radio,
	children,
}: Omit<ComplexProps, 'type'>): JSX.Element {
	return (
		<Button
			data-testid="selection-card-complex-button"
			className="min-h-[72px]} flex flex-col items-start gap-4 self-stretch text-left"
			selected={selected}
			onClick={onSelect}
			as="div"
		>
			<div className="flex flex-col items-start gap-4 self-stretch text-left">
				{badgeText && (
					<Badge
						data-testid="selection-card-complex-badge"
						position="top"
						badge={{
							position: 'top',
							label: badgeText,
							icon: <Icon icon={iconStar} />,
						}}
					/>
				)}
				<div className={cn({ 'flex items-start gap-3 self-stretch': !!Radio })}>
					{Radio && <Radio />}
					<div className="flex flex-col items-start gap-4 self-stretch text-left">
						<Text data-testid="selection-card-complex-label" variant="body" fontWeight="bold">
							{label}
						</Text>
						<Text
							data-testid="selection-card-complex-message"
							variant="body"
							className={cn('w-full', { 'text-typography-strong': selected, 'text-typography-weak': !selected })}
						>
							{description}
						</Text>
						<div data-testid="selection-card-complex-slot" className="w-full">
							{children}
						</div>
					</div>
				</div>
			</div>
		</Button>
	);
}
